export default __webpack_public_path__ + "static/media/student.b3f45155.png";